import Typography from '@material-ui/core/Typography';
import { RulesConfigurationFormType } from '../../types/types';
import { FieldArray, useFormikContext } from 'formik';
import { Button } from '@vadiun/react-components';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC } from 'react';
import { PolygonZone } from 'shared/models/PolygonZones';
import { Stage } from 'shared/models/Stages';
import clsx from 'clsx';
import TravelStatusTimeline from './TravelStatusTimeline';
import { ChannelType } from 'shared/models/ChannelTyoes';


interface TravelStatusStepProps {
    stagesOfReserveStatesOptions: Stage[];
    polygonZonesOptions: PolygonZone[];
    channels: ChannelType[];
    readOnly?: boolean;
}



const TravelStatusStep: FC<TravelStatusStepProps> = ({
    stagesOfReserveStatesOptions,
    polygonZonesOptions,
    channels,
    readOnly = false
}) => {
    const { values, errors, touched } = useFormikContext<RulesConfigurationFormType>();

    const getOrderedStates = () => {
        const states = [];
        values.stages.forEach((stage, index) => {
            if (stage.stage_id) {
                if (index === 0) {
                    const stageObject = stagesOfReserveStatesOptions.find(s => s.id === stage.stage_id);
                    if (stageObject) {
                        states.push(stageObject.from_state.name as never);
                        states.push(stageObject.to_state.name as never);
                    }
                } else {
                    const stageObject = stagesOfReserveStatesOptions.find(s => s.id === stage.stage_id);
                    if (stageObject) {
                        states.push(stageObject.to_state.name as never);
                    }
                }
            }
        });
        return states;
    };
    const stagesCount = values.stages.length;
    const stagesOptionsCount = stagesOfReserveStatesOptions.length;
    return (
        <div className="flex flex-col w-full gap-6 bg-white rounded-2xl shadow-lg border border-gray-100 p-6" style={{ minWidth: '600px' }}>
            <div className="flex w-full items-center gap-4 bg-bgInputSection rounded-xl border border-borderInputSection p-2">
                <Typography variant="h6" className="font-bold text-gray-800 whitespace-nowrap">
                    {values.name}
                </Typography>
            </div>

            <FieldArray name="stages">
                {({ push, remove }) => (
                    <div className="flex w-full flex-col justify-center items-center">

                        <div className="flex w-full items-center gap-4 justify-between ">
                            <div className="flex w-full items-center gap-4">
                                <div className="w-2 h-8 bg-secondary-500 rounded-full" />
                                <Typography variant="h6" className="font-bold text-secondary-700 whitespace-nowrap">
                                    Estados de Viaje
                                </Typography>
                            </div>
                            {!readOnly && (
                                <div className="flex w-auto items-center gap-4 justify-end border-borderInputSection rounded-md border-2">
                                    <Button
                                        variant="text"
                                        className='text-green-700 hover:text-green-500'
                                        color=""
                                        disabled={stagesCount === stagesOptionsCount}
                                        onClick={() => push({
                                            stage_id: stagesOfReserveStatesOptions.sort((a, b) => a.id - b.id)[values.stages.length].id, semaphores: [
                                                {
                                                    semaphore_levels: [
                                                        { semaphore_color_key: 'green', threshold_minutes: 0, semaphore_message_templates: { id: undefined, channel_id: [], title: '', body: '' } },
                                                        { semaphore_color_key: 'yellow', threshold_minutes: 0, semaphore_message_templates: { id: undefined, channel_id: [], title: '', body: '' } },
                                                        { semaphore_color_key: 'orange', threshold_minutes: 0, semaphore_message_templates: { id: undefined, channel_id: [], title: '', body: '' } },
                                                        { semaphore_color_key: 'red', threshold_minutes: 0, semaphore_message_templates: { id: undefined, channel_id: [], title: '', body: '' } },
                                                    ],
                                                }
                                            ], has_polygon: false, is_countdown: false
                                        })}
                                    >
                                        <FontAwesomeIcon
                                            icon={faPlus}
                                            size='2x'
                                        />
                                    </Button>
                                    <Button
                                        variant="text"
                                        color=""
                                        className='text-red-700 hover:text-red-500'
                                        disabled={
                                            values.stages.length === 0
                                        }
                                        onClick={() =>
                                            remove(values.stages.length - 1)
                                        }
                                    >
                                        <FontAwesomeIcon icon={faMinus} size='2x' />
                                    </Button>
                                </div>
                            )}
                        </div>

                        <div
                            className={clsx(
                                "flex w-full px-6 justify-start mx-2",
                                values.stages.length > 0 && "mt-12"
                            )}
                        >
                            <TravelStatusTimeline
                                orderedStates={getOrderedStates()}
                                readOnly={readOnly}
                                polygonZonesOptions={polygonZonesOptions}
                                channels={channels}
                            />
                        </div>
                    </div>
                )}
            </FieldArray>
            {errors.stages && touched.stages && (
                <span className="text-red-500 text-xs">{errors.stages}</span>
            )}
        </div>
    );
};

export default TravelStatusStep;
